<p-dialog-container>
    <p-dialog-header [title]="'UserProfile.Security.AddMethod.header' | translate"></p-dialog-header>
    <div class="p-dialog-content">
        <div class="method-menu" role="menu">
            <button
                type="button"
                class="method-menu__item"
                role="menuitem"
                *ngFor="let option of options"
                (click)="select(option.method)"
                [attr.automation-id]="'add_method_' + option.key"
            >
                <span class="method-menu__title">
                    <p-icon [name]="option.icon" color="base-dark"></p-icon>
                    {{ 'UserProfile.Security.Methods.' + option.key + '.Name' | translate }}
                </span>
                <span class="method-menu__description">{{
                    'UserProfile.Security.Methods.' + option.key + '.Description' | translate
                }}</span>
            </button>
        </div>
    </div>
    <p-dialog-footer [btnConfig]="footerConfig"></p-dialog-footer>
</p-dialog-container>
